import { render, staticRenderFns } from "./FooterComponents.vue?vue&type=template&id=79ead99a&scoped=true"
import script from "./FooterComponents.vue?vue&type=script&lang=js"
export * from "./FooterComponents.vue?vue&type=script&lang=js"
import style0 from "./FooterComponents.vue?vue&type=style&index=0&id=79ead99a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ead99a",
  null
  
)

export default component.exports